<template lang="pug">
  .table-container
    table#Ingresos.table.is-striped.is-narrow
      thead
        tr
          th.is-size-7.dobleFila(rowspan="2" align="center" vertical-align="center")
            | Nombre Completo
          th.is-size-7.dobleFila(rowspan="2" align="center" vertical-align="center")
            | Hora
          th.is-size-7.dobleFila(rowspan="2" align="center" vertical-align="center")
            | Temp.
            br
            | (HOY)
          th.is-size-7.dobleFila(rowspan="2" vertical-align="center")
            | Firma
          th.dobleFila(colspan="11" align="center" vertical-align="center")
            | SINTOMAS (Pulsa si haz tenido algun síntoma)
        tr
          th.dobleFila.is-size-7(align="center")
            | Fiebre Mayor a 37.5°C
          th.dobleFila.is-size-7(align="center")
            | Tos Seca
          th.dobleFila.is-size-7(align="center")
            | Dolor de Cabeza
          th.dobleFila.is-size-7(align="center")
            | Escurrimiento Nasal
          th.dobleFila.is-size-7(align="center")
            | Perd. Olfato Gusto
          th.dobleFila.is-size-7(align="center")
            | Dolor Muscular
          th.dobleFila.is-size-7(align="center")
            | Ojos Irritados
          th.dobleFila.is-size-7(align="center")
            | Dolor de Garganta
          th.dobleFila.is-size-7(align="center")
            | Dificultad Respiratoria
          th.dobleFila.is-size-7(align="center")
            | Contacto con Persona con Síntomas Anteriores
          th.dobleFila.is-size-7(align="center")
            | Contacto con algún caso positivo de Covid 19
      tbody
        tr(v-for="a in visitas" :key="a.id")
          td.is-size-7(align="center")
            span
              | {{ a.nombre }}&nbsp
            a.button.is-danger.is-small.is-rounded(@click="eliminarVisita(a)")
              span.icon
                i.fas.fa-trash
          td.is-size-7(align="center")
            span.tag
              | {{ a.hora }}
          td.is-size-7(align="center")
            | {{ a.temperatura }}°C
          td.is-size-7(align="center")
            figure.image.is-128x128(v-show="a.firma !== ''")
              img(:src="a.firma")
            span.tag.danger(v-show="a.firma === ''")
              | Sin Firma
          td.is-size-7(align="center")
            span.tag(:class="a.fiebre == 1 ? 'is-danger' : 'is-success'")
              | {{ a.fiebre == 1 ? 'SI' : 'NO'}}
          td.is-size-7(align="center")
            span.tag(:class="a.tos == 1 ? 'is-danger' : 'is-success'")
              | {{ a.tos == 1 ? 'SI' : 'NO'}}
          td.is-size-7(align="center")
            span.tag(:class="a.dolorC == 1 ? 'is-danger' : 'is-success'")
              | {{ a.dolorC == 1 ? 'SI' : 'NO'}}
          td.is-size-7(align="center")
            span.tag(:class="a.escurrimiento == 1 ? 'is-danger' : 'is-success'")
              | {{ a.escurrimiento == 1 ? 'SI' : 'NO'}}
          td.is-size-7(align="center")
            span.tag(:class="a.olfatoGusto == 1 ? 'is-danger' : 'is-success'")
              | {{ a.olfatoGusto == 1 ? 'SI' : 'NO'}}
          td.is-size-7(align="center")
            span.tag(:class="a.dolorM == 1 ? 'is-danger' : 'is-success'")
              | {{ a.dolorM == 1 ? 'SI' : 'NO'}}
          td.is-size-7(align="center")
            span.tag(:class="a.ojosI == 1 ? 'is-danger' : 'is-success'")
              | {{ a.ojosI == 1 ? 'SI' : 'NO'}}
          td.is-size-7(align="center")
            span.tag(:class="a.dolorG == 1 ? 'is-danger' : 'is-success'")
              | {{ a.dolorG == 1 ? 'SI' : 'NO'}}
          td.is-size-7(align="center")
            span.tag(:class="a.dificultadR == 1 ? 'is-danger' : 'is-success'")
              | {{ a.dificultadR == 1 ? 'SI' : 'NO'}}
          td.is-size-7(align="center")
            span.tag(:class="a.contactoS == 1 ? 'is-danger' : 'is-success'")
              | {{ a.contactoS == 1 ? 'SI' : 'NO'}}
          td.is-size-7(align="center")
            span.tag(:class="a.contactoC19 == 1 ? 'is-danger' : 'is-success'")
              | {{ a.contactoC19 == 1 ? 'SI' : 'NO'}}
</template>

<script>
  export default {
    name: 'TbVisitas',
    props: {
      visitas: {
        type: Array,
        default: () => []
      },
    },
    methods: {
      editarVisita(a) {
        this.$emit('editarVisita', a)
      },
      eliminarVisita(a) {
        this.$emit('eliminarVisita', a)
      }
    },
  }
</script>

<style scoped>
  .is-size-7.dobleFila {
    vertical-align: middle;
  }
</style>


// WEBPACK FOOTER //
// src/components/visitas_Componentes/components/TbVisitas.vue